import styled, { css } from 'styled-components'

export interface PresetButtonStyledProps {
  $active?: boolean
  $size?: 'small' | 'medium' | 'large'
}

const sizeStyles = {
  small: css`
    padding: ${({ theme }) => theme.spacing.micro}
      ${({ theme }) => theme.spacing.small};
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
    min-height: 24px;
  `,
  medium: css`
    padding: ${({ theme }) => theme.spacing.small}
      ${({ theme }) => theme.spacing.default};
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    min-height: 32px;
  `,
  large: css`
    padding: ${({ theme }) => theme.spacing.default}
      ${({ theme }) => theme.spacing.medium};
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    min-height: 40px;
  `,
}

export const Button = styled.button<PresetButtonStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.default};
  white-space: nowrap;
  user-select: none;
  text-align: center;
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};

  ${({ $size = 'medium' }) => sizeStyles[$size]}

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.background.secondary};
    border-color: ${({ theme }) => theme.colors.border.focus};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.border.focus};
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &:active:not(:disabled) {
    background: ${({ theme }) => theme.colors.background.tertiary};
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.tertiary};
    border-color: ${({ theme }) => theme.colors.border.light};
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.colors.primary};
      color: ${theme.colors.text.inverse};
      border-color: ${theme.colors.primary};
      font-weight: ${theme.typography.fontWeight.semibold};

      &:hover:not(:disabled) {
        background: ${theme.colors.primaryHover};
        border-color: ${theme.colors.primaryHover};
      }

      &:focus {
        box-shadow: 0 0 0 3px rgba(0, 173, 230, 0.25);
      }
    `}
`
